// src/components/ui/tooltip.jsx
import * as Tooltip from "@radix-ui/react-tooltip";

export const TooltipProvider = Tooltip.Provider;
export const TooltipTrigger = Tooltip.Trigger;
export const TooltipContent = Tooltip.Content;
export const TooltipArrow = Tooltip.Arrow;